import { render } from "./PantryListEmptyView.vue?vue&type=template&id=2aa870c6&ts=true"
import script from "./PantryListEmptyView.vue?vue&type=script&lang=ts"
export * from "./PantryListEmptyView.vue?vue&type=script&lang=ts"

import "./PantryListEmptyView.vue?vue&type=style&index=0&id=2aa870c6&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__